import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-change-transparency',
  templateUrl: './change-transparency.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ChangeTransparencyComponent implements OnInit {

  @Input() transparency:number;
  onClose: Subject<number>;


  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }
  ok(){
    this.bsModalRef.hide();
    this.onClose.next(+this.transparency);
  }
}
